import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', [
    'loggedIn',
    'currentUserGroups',
    'currentUserRoles',
    'currentUserPermissions',
    'canCurrentUserRead',
  ]),
}

export const authMethods = mapActions('auth', ['logIn', 'logOut'])

export const propertiesComputed = {
  ...mapState('properties', {
    properties: (state) => state.all,
    propertiesLoaded: (state) => state.loaded,
  }),
}

export const propertiesMethods = mapActions('properties', {
  fetchAllProperties: 'fetchAll',
  fetchNearbyAmenitiesForProperty: 'fetchNearbyAmenitiesForProperty',
  fetchNearby: 'fetchNearby',
})

export const propertiesSearchComputed = {
  ...mapState('propertiesSearch', {
    propertiesSearchFilters: (state) => state.filters,
    propertiesSearchSorts: (state) => state.sorts,
    propertiesSearchSelectedSort: (state) => state.selectedSort,
    propertiesSearchJustUpdated: (state) => state.justUpdated,
  }),
  ...mapGetters('propertiesSearch', {
    propertiesSearchResults: 'results',
    propertiesSearchResultsSorted: 'resultsSorted',
  }),
}

export const propertiesSearchMethods = mapActions('propertiesSearch', {
  updatePropertiesSearchFilters: 'updateFilters',
  updatePropertiesSearchSelectedSort: 'updateSelectedSort',
  updatePropertiesSearchSelectedSortValue: 'updateSelectedSortValue',
  resetPropertiesSearchState: 'resetState',
})

export const mapMethods = {
  ...mapActions('map', ['updateMap', 'centerOnAddress']),
  ...mapActions('map', {
    resizeMap: 'resize',
  }),
}

export const sidebarComputed = {
  ...mapState('sidebar', {
    sidebarWidthInPixels: (state) => state.widthInPixels,
  }),
}

export const sidebarMethods = {
  ...mapActions('sidebar', {
    updateSidebarWidth: 'updateWidth',
  }),
}

export const contentBlocksComputed = {
  ...mapGetters('contentBlocks', ['getContentBlock']),
}
